export default {
  2: '帐号或者密码错误', // '用户名不存在'
  3: '帐号或者密码错误', // '密码错误'
  4: '该用户已注册',
  5: '验证码错误',
  7: '您的登录状态已失效，请重新登录',
  8: '密码不符合规则',
  17: '网盘容量已满，上传失败',
  23: '发送太频繁',
  24: '该手机号被运营商拦截',
  33: '同名文件冲突',
  46: '余额不足',
  49: '该生申请之前已经通过',
  51: '暂无权限访问',
  56: `无法申请自己创建的课程`,
  75: '该课程已停止选课',
  130: '该算力豆申请已被其他人处理，请勿重复操作'
}
